










 

 















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSubscription_paymentRejected",
  "selections": [
    {
      "alias": "paymentRejectedNotification",
      "args": null,
      "concreteType": "NotifyPaymentRejected",
      "kind": "LinkedField",
      "name": "notification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentRejected_notification"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StripeFailPaymentPayload",
  "abstractKey": null
};

(node ).hash = "0a56392f7720c82c1995fa33a93de3ad";

export default node;
